import { defineTrpcContract, mutation, query } from "@amtana/module";

import { emptyInputSchema, purgeInputSchema, purgeResultSchema, usageSchema } from "./settings.schemas.ts";

export const settingsTrpcContract = defineTrpcContract("settings", {
  usage: query({ input: emptyInputSchema, output: usageSchema }),
  purge: mutation({ input: purgeInputSchema, output: purgeResultSchema }),
});
